import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const customEmailValidator: ValidatorFn = (c: AbstractControl): ValidationErrors | null => {
  const email = c.value;

  if (!email) {
    return null;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const valid = emailRegex.test(email);
  return valid ? null : { invalidEmail: true };

  return null;
};
